import type { MutationTree } from "vuex";
import type { SpacePresenceState } from "./state";
import { initSpacePresenceState } from "./state";
import type { SpaceMember } from "@ably/spaces";
import type { PresenceData } from "@/models";
import type { RealtimeSpace } from "@/ws/realtime-space";
import { defineVuexName, MODULES } from "../utils";

const mutations: MutationTree<SpacePresenceState> = {
  [defineVuexName(MODULES.SPACE_PRESENCE.COMMITS.SET_INSTANCE)](state, instance?: RealtimeSpace) {
    state.instance = instance;
  },
  [defineVuexName(MODULES.SPACE_PRESENCE.COMMITS.SET_CHANNEL_NAME)](state, spaceChannelName?: string) {
    state.spaceChannelName = spaceChannelName;
  },
  [defineVuexName(MODULES.SPACE_PRESENCE.COMMITS.SET_MEMBERS)](state, members: SpaceMember[]) {
    const memberMap: Record<string, SpaceMember> = {};
    members.forEach((member) => {
      memberMap[member.connectionId] = member;
    });
    state.members = memberMap;
  },
  [defineVuexName(MODULES.SPACE_PRESENCE.COMMITS.SET_PROFILE_DATA)](state, profileData?: PresenceData) {
    state.profileData = profileData;
  },
  [defineVuexName(MODULES.SPACE_PRESENCE.COMMITS.RESET_STATE)](state) {
    const next = initSpacePresenceState();
    state.instance = next.instance;
    state.members = next.members;
    state.spaceChannelName = next.spaceChannelName;
    state.profileData = next.profileData;
  },
};

export default mutations;
